import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import {
  AuthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
  useMsalAuthentication,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";

import { useAppContext } from "../provider/AppContextProvider";
import RouteList from "./RouteList";
import { useGlobalContext } from "../provider/GlobalContextProvider";
// import { APP_ROUTE_MAIN_PATHS } from './appRoutes';

const Loader: React.FC<{ showLoader: boolean }> = ({ showLoader }) => {
  return <div className="loader">{showLoader && <p>Loading...</p>}</div>;
};

const AuthProtectedRoutes = () => {
  const { instance } = useMsal();
  const { updateGLoading } = useGlobalContext();
  
  const { result, acquireToken } = useMsalAuthentication(
    InteractionType.Redirect,
    { domainHint: process.env.REACT_APP_WUCA_DOMAIN_HINT }
  );

  const isAuthenticated = useIsAuthenticated();

  const { setToken } = useAppContext();
  const { setUserName } = useAppContext();
  useEffect(() => {
    if (!isAuthenticated) return;

    const obtainIdToken = async () => {
      console.log('Obtaining ID token...');
      updateGLoading(true, "globalLoaderAuth");

      await instance.initialize();
      const tokensData = await acquireToken();
      if (tokensData?.idToken) {
        setToken(tokensData?.idToken);
        sessionStorage.setItem("authToken", tokensData?.idToken || ""); // switched from sessionStorage
      }
       if (tokensData?.account.name) {
        setUserName(tokensData?.account.name);
      }
      updateGLoading(false, "globalLoaderAuth");
    };

    obtainIdToken();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result?.idToken, isAuthenticated]);

  // useEffect(() => {
  //   if (!isAuthenticated) return;

  //   const obtainUserDetails = async () => {
  //     console.log('Obtaining user details...');
  //     await instance.initialize();
  //     const tokensData = await acquireToken();
  //     if (tokensData?.account.name) {
  //       setUserName(tokensData?.account.name);
  //     }
  //   };

  //   obtainUserDetails();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [result?.account.name, isAuthenticated]);

  return (
    <AuthenticatedTemplate>
      <React.Suspense fallback={<Loader showLoader={true} />}>
        <RouteList />
      </React.Suspense>
    </AuthenticatedTemplate>
  );
};

export default AuthProtectedRoutes;
